import { type PatientOption } from '../../services/faxClassification';
import { type IntakeDraft } from '../../services/intakeDrafts';

/**
 * How a patient and a draft read in the picker and on an inbox row.
 *
 * Their own module rather than the picker's, because a file that exports
 * anything but components loses fast refresh for the component beside them,
 * and the lint gate treats that warning as an error.
 */

export function patientLabel(patient: PatientOption): string {
  return `${patient.last_name}, ${patient.first_name}${
    patient.mrn ? ` (${patient.mrn})` : ''
  }`;
}

export function draftSummary(draft: IntakeDraft): string {
  const count =
    draft.document_count === 1
      ? '1 document'
      : `${draft.document_count} documents`;
  return draft.created_by_name ? `${count} · ${draft.created_by_name}` : count;
}
